<h2 mat-dialog-title>{{ data.title || 'Please confirm' }}</h2>

<mat-dialog-content>
  <p>{{ data.message }}</p>

  <!-- bankRemoval variant -->
  @if (data.confirmType === 'bankRemoval') {
    <p class="bank-summary">
      <br>
        <strong>{{ data.nickname }}</strong> {{ data.last4 }}
      </p>
    } @else {
      <p><strong>Type:</strong> {{ data.typeLabel }}</p>
      <p><strong>ID:</strong> {{ data.idLabel }}</p>
    }

    <!-- generic Type/ID info -->
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">
      {{ data.cancelText || 'No' }}
    </button>
    <button mat-flat-button color="warn" (click)="onConfirm()">
      {{ data.confirmText || 'Yes' }}
    </button>
  </mat-dialog-actions>
